import { useCustomerCredit } from '@order/hooks';
import { useFeatureFlag } from '@order/LaunchDarkly';

/**
 * To only query with cache if the feature flag is on.
 */
export function useCheckoutAvailableCredit() {
  const shouldQueryWithCache = useFeatureFlag(
    'CELS-1410-separate-promo-and-gift-card',
  );

  return useCustomerCredit({
    requestPolicy: shouldQueryWithCache ? 'cache-and-network' : 'network-only',
  });
}
